export default __webpack_public_path__ + "static/media/frame.0b0005eb.png";